import React from 'react';
import { View, StyleSheet } from 'react-native';

import { Modal } from './modal';
import { Text } from './text';

import { useTheme } from '@/components/theme-provider';

export interface DialogProps {
	visible: boolean;
	onDismiss?: () => void;
	title?: string;
	children?: React.ReactNode;
	actions?: React.ReactNode;
	style?: any;
	testID?: string;
}

const DialogBase: React.FC<DialogProps> = ({
	visible,
	onDismiss,
	title,
	children,
	actions,
	style,
	testID,
}) => {
	const theme = useTheme();

	return (
		<Modal visible={visible} onDismiss={onDismiss}>
			<View testID={testID} style={[styles.dialog, { backgroundColor: theme.colors.surface }, style]}>
				{title && (
					<Text variant="titleLarge" style={styles.title}>
						{title}
					</Text>
				)}
				{children && (
					<View style={styles.content}>
						{children}
					</View>
				)}
				{actions && (
					<View style={styles.actions}>
						{actions}
					</View>
				)}
			</View>
		</Modal>
	);
};

// Dialog sub-components
export const DialogTitle: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	return (
		<Text variant="titleLarge" style={styles.title}>
			{children}
		</Text>
	);
};

export const DialogContent: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	return (
		<View style={styles.content}>
			{children}
		</View>
	);
};

export const DialogActions: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	return (
		<View style={styles.actions}>
			{children}
		</View>
	);
};

// Create a properly typed Dialog component with sub-components
const Dialog = Object.assign(DialogBase, {
	Title: DialogTitle,
	Content: DialogContent,
	Actions: DialogActions,
});

export { Dialog };

const styles = StyleSheet.create({
	dialog: {
		borderRadius: 8,
		padding: 8,
		minWidth: 280,
		maxWidth: 560,
	},
	title: {
		marginBottom: 16,
		fontWeight: 'bold',
	},
	content: {
		margin: 0,
	},
	actions: {
		borderTopWidth: StyleSheet.hairlineWidth,
		borderTopColor: '#ccc',
		flexDirection: 'row',
		justifyContent: 'flex-end',
		gap: 16,
		marginTop: 24,
	},
});
